
@if (!chartReady()) {
  <div class="w-full relative">
  <div class="bg-white rounded rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</div>
} @else {
  <co-chart-card
  [chartHeader]="chartHeader()"
  [cssClass]="cssClass()"
  [filterOptions]="filterOptions()"
  [selectedFilters]="selectedFilters"
  (onFilterChange)="onDropdownChange()"
  [testResult]="testResult()"
 
>

  <div chart-content>
    @if (chartData().length) {
    <apx-chart
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [markers]="chartOptions.markers"
      [stroke]="chartOptions.stroke"
      [yaxis]="chartOptions.yaxis"
      [dataLabels]="chartOptions.dataLabels"
      [title]="chartOptions.title"
      [fill]="chartOptions.fill"
      [tooltip]="chartOptions.tooltip"
      [legend]="chartOptions.legend"
    ></apx-chart>
    <!-- <div style="margin-top: 16px">
      <strong>Chi-squared Goodness-of-Fit Test:</strong><br />
      <strong
        >H0: Current claim proportions follow the historical
        distribution.</strong
      ><br />
      <strong
        >Chi-squared Statistic: {{ chiSquaredResult().statistic.toFixed(2) }},
        p-value: {{ chiSquaredResult().pValue.toFixed(2) }}</strong
      ><br />
      <strong
        >Conclusion (at alpha=0.05): {{ chiSquaredResult().conclusion }}</strong
      ><br />
    </div> -->
    }
   @else
    {
    <div class="flex items-center justify-center">
      <span class="text-black-500 text-lg font-medium">{{"REPORTS.NO_DATA_FOUND" | translate}}</span>
    </div>
    }
  </div>
</co-chart-card>
}
